import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import RadioButtonGroup from "../../elements/radio-button-group";
import ColorPicker from "../../elements/color-picker";
import "./style.scss";

export default function ProductDetailSelectionForm({ variants, availableVariants, onSelectionChanged = () => {} }) {
  const [selectedOptions, setSelectedOptions] = useState(
    variants.map(item => {
      return item.selectedOption;
    })
  );

  const [radioButtonOptions, setRadioButtonOptions] = useState(variants.find(item => item.type === "radio")?.options);
  const [imageOptions, setImageOptions] = useState(variants.find(item => item.type === "image")?.options);

  const loadAvailableVariants = () => {
    //in case of size and color available check for variants in stock
    if (variants.length > 1) {
      let color = variants.find(variant => variant.type?.toLowerCase() === "image");
      let size = variants.find(variant => variant.type?.toLowerCase() === "radio");
      let sizesPerColor = [];
      size &&
        size.options.forEach(option => {
          let foundVariant = availableVariants.find(variant => variant.size === option.value && variant.color === color.selectedOption.label);

          option.soldOut = foundVariant.soldOut;
          option.usableStock = foundVariant.usableStock;
          foundVariant && sizesPerColor.push(option);
        });

      setRadioButtonOptions(sizesPerColor);
    }
  };

  useEffect(() => {
    availableVariants && loadAvailableVariants();
  }, [availableVariants]);

  const setOption = (option, index) => {
    let newSelectedOptions = [...selectedOptions];
    newSelectedOptions[index] = option;
    setSelectedOptions(newSelectedOptions);
    const variant = variants[index];
    if (variants.length === 2)
      if (variant.type === "radio") {
        let color = variants.find(variant => variant.type === "image");
        let colorsPerSize = [];
        color.options.forEach(obj => {
          let foundVariant = availableVariants.find(variant => variant.size === option.label && variant.color === obj.value);
          obj.soldOut = foundVariant.soldOut;
          obj.usableStock = foundVariant.usableStock;
          foundVariant && colorsPerSize.push(obj);
        });

        setImageOptions(colorsPerSize);
      } else {
        let size = variants.find(variant => variant.type === "radio");
        let sizePerColor = [];
        size.options.forEach(obj => {
          let foundVariant = availableVariants.find(variant => variant.color === option.label && variant.size === obj.value);
          obj.soldOut = foundVariant.soldOut;
          obj.usableStock = foundVariant.usableStock;
          foundVariant && sizePerColor.push(obj);
        });
        setRadioButtonOptions(sizePerColor);
      }
    if (typeof variant.onChange === "function") variant.onChange(option);
    onSelectionChanged(newSelectedOptions);
  };

  return (
    <form className="product-detail-selection-form">
      {variants &&
        variants.map((item, index) => {
          return (
            <div className="variant" key={`variant-${index}`}>
              {item.type === "image" && (
                <>
                  <div className="variant-title">
                    <span className="label">{item.label}</span>
                    <span className="value">{selectedOptions[index] ? selectedOptions[index].label : ""}</span>
                  </div>
                  <div className="variant-input">
                    <ColorPicker
                      {...{
                        options: imageOptions,
                        selectedOption: item.selectedOption,
                        onChange: (event, option) => setOption(option, index)
                      }}
                    />
                  </div>
                </>
              )}
              {item.type === "radio" && (
                <>
                  <div className="variant-title">
                    <span className="label">{item.label}</span>
                  </div>
                  <div className="variant-input">
                    <RadioButtonGroup
                      {...{
                        ...item,
                        options: radioButtonOptions,
                        onChange: option => setOption(option, index)
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          );
        })}
    </form>
  );
}

ProductDetailSelectionForm.propTypes = {
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
      selectedOption: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
        image: PropTypes.shape({
          src: PropTypes.string,
          alt: PropTypes.string
        })
      }),
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
          image: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string
          })
        })
      ),
      onChange: PropTypes.func
    })
  )
};
